"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var SecureIcon =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(SecureIcon, _PureComponent);

  function SecureIcon() {
    _classCallCheck(this, SecureIcon);

    return _possibleConstructorReturn(this, _getPrototypeOf(SecureIcon).apply(this, arguments));
  }

  _createClass(SecureIcon, [{
    key: "render",
    value: function render() {
      var color = this.props.color;
      return _react2.default.createElement("svg", {
        id: "Group_2072",
        "data-name": "Group 2072",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 80.35 80.352",
        style: {
          fill: color
        }
      }, _react2.default.createElement("g", {
        id: "Group_1790",
        "data-name": "Group 1790",
        transform: "translate(28.923 31.791)"
      }, _react2.default.createElement("path", {
        id: "Path_1301",
        "data-name": "Path 1301",
        d: "M-19.078-34.883l-3.653,3.214,8.765,9.77.017-.017.012.017L1.782-37.874l-2.806-3.688L-13.8-31.048Z",
        transform: "translate(22.731 41.562)"
      })), _react2.default.createElement("g", {
        id: "Group_1792",
        "data-name": "Group 1792",
        clipPath: "url(#clip-path)"
      }, _react2.default.createElement("g", {
        id: "Group_1791",
        "data-name": "Group 1791",
        transform: "translate(0 0)"
      }, _react2.default.createElement("path", {
        id: "Path_1302",
        "data-name": "Path 1302",
        d: "M-209.82-325.769c-20.673,0-22.145-34.977-22.145-34.977l22.145-9.424h0l22.145,9.424s-1.473,34.977-22.145,34.977m0-62.375a40.175,40.175,0,0,0-40.174,40.175,40.176,40.176,0,0,0,40.174,40.176,40.177,40.177,0,0,0,40.175-40.176,40.176,40.176,0,0,0-40.175-40.175",
        transform: "translate(249.995 388.144)"
      }))));
    }
  }]);

  return SecureIcon;
}(_react.PureComponent);

exports.default = SecureIcon;